import { Reveal, Eyebrow } from "../lib/data";

const Manifesto = () => (
  <section className="py-24 lg:py-32 bg-[#FBF7EF] relative overflow-hidden" data-testid="manifesto-section">
    <div className="max-w-4xl mx-auto px-6 text-center">
      <Reveal>
        <Eyebrow>Manifestul nostru</Eyebrow>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-[#2A2521] mt-6 leading-[1.15]">
          Nu credem în soluții rapide. <span className="text-[#A6823B]">Credem în rezultate care țin.</span>
        </h2>
        <p className="text-[#6B5C43] mt-8 text-base md:text-lg leading-relaxed max-w-2xl mx-auto">
          MEDAS Dental Point este locul pacienților care vor lucruri făcute bine: cu timp, cu atenție
          și cu grijă la fiecare detaliu. La noi, sănătatea zâmbetului tău nu e o promisiune —
          e o certitudine.
        </p>
      </Reveal>
    </div>
  </section>
);

export default Manifesto;
